let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cAPnh")).then(() => parcelRequire('8j2ZH'));